@if(loadingTable$$()) {
  <app-bm-loading-table/>
} @else {
  <div class="table-fms" [formGroup]="budgetForm">
    <table>
      <thead
        app-table-budget-model-headers
        [budgetForm]="budgetForm"
        [collapsedYears]="collapsedYears$$()">
      </thead>

      <tbody
        app-table-budget-model-body-mgm
        [budgetForm]="budgetForm"
        [collapsedYears]="collapsedYears$$()"
        [isEditState]="isEditState$$()">
      </tbody>

      <!-- Operating Expenses -->
      <tbody
        app-table-budget-model-body-operating-expenses
        cdkDropList
        [budgetForm]="budgetForm"
        [collapsedYears]="collapsedYears$$()"
        [isEditState]="isEditState$$()"
        (cdkDropListDropped)="changeOrderInExpensesGroup($event, budgetForm.controls.modelData.controls.operatingExpenses.controls.groups)">
      </tbody>

      <!--  Organizational expenses      -->
      <tbody
        app-table-budget-model-body-org-expenses
        cdkDropList
        [budgetForm]="budgetForm"
        [collapsedYears]="collapsedYears$$()"
        [isEditState]="isEditState$$()"
        (cdkDropListDropped)="changeOrderInExpensesGroup($event, budgetForm.controls.modelData.controls.organizationalExpenses.controls.groups)">
      </tbody>

      <!-- Total expenses      -->
      <tbody
        app-table-budget-model-body-total-expenses
        [collapsedYears]="collapsedYears$$()"
        [budgetForm]="budgetForm"
        [isEditState]="isEditState$$()">
      </tbody>

      <tfoot
        app-table-budget-model-tfoot
        [budgetForm]="budgetForm"
        [collapsedYears]="collapsedYears$$()">
      </tfoot>
    </table>
  </div>
}
